'use client'

import Script from 'next/script'

export default function CouponBar({ widgetIds }: { widgetIds: string[] }) {
  const ids = widgetIds.map(s => s.trim()).filter(Boolean)
  if (ids.length === 0) return null
  const idsProp = ids.join(',')

  const src = `https://cdn.commoninja.com/sdk/latest/commonninja.js?widgetIds=${encodeURIComponent(idsProp)}`

  return (
    <Script
      id={`commonninja-${idsProp}`}
      key={`commonninja-${idsProp}`}
      src={src}
      strategy='afterInteractive'
      onLoad={() => {
        window.CommonNinja?.refresh?.()
      }}
    />
  )
}
